import {
    CHANGE_OLD_INSURANCE, LOAD_LAST_ORDER, OLD_DATA_OFF
} from '../actions/types';

const INITIAL_STATE = {
    oldInsurance:false,
    data: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHANGE_OLD_INSURANCE:
            return {
                ...state,
                oldInsurance: action.payload
            };
        case LOAD_LAST_ORDER:
            return {
                ...state,
                data: action.payload,
            } ;
        case OLD_DATA_OFF:
            return {
                ...state,
                oldInsurance:false,
            }
        default:
            return state;
    }
};
